import { useCallback } from 'react';

import { useAuthenticatedUser } from 'features/authentication';
import { usePermissions } from 'features/permissions';

export function useCanManageJobAccess() {
  const me = useAuthenticatedUser();
  const { hasRolePermission } = usePermissions();

  return useCallback(
    (createdById: number | null | undefined) => {
      return me.id === createdById || hasRolePermission('job:access:manage');
    },
    [me.id, hasRolePermission],
  );
}

export function useManageJobAccess(createdById: number | null | undefined) {
  return useCanManageJobAccess()(createdById);
}
